import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// Define input size variants
const inputVariants = cva('flex w-full bg-light-light rounded-md border border-input text-sm ring-offset-0 ring-offset-background hover:border-gray-400 focus:ring-offset-0 focus:border-primary placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50', {
  variants: {
    size: {
      default: 'h-10 px-3 py-2',
      sm: 'h-8 px-2 py-1',
      lg: 'h-11 px-4 py-3'
    }
  },
  defaultVariants: {
    size: 'default'
  }
});
const Input = React.forwardRef(({
  className,
  type,
  size,
  ...props
}, ref) => {
  return <input type={type} className={cn(inputVariants({
    size
  }), className)} ref={ref} {...props} />;
});
Input.displayName = 'Input';
export { Input, inputVariants };